import enUS from './enUS'

const enCA = {
  ...enUS
}

export default enCA
